import defaultsDeep from 'lodash/defaultsDeep'
import actionTypes from 'constants/actionTypes'

interface GraphQueryState {
  isFetching: boolean
  failed: boolean
  showModal: boolean
  status: string
}

interface GraphQueryAction {
  type: string
  payload?: string
}

const initialState: GraphQueryState = {
  isFetching: false,
  failed: false,
  showModal: false,
  status: '',
}


export default (state: GraphQueryState = initialState, action: GraphQueryAction): GraphQueryState => {
  if (action.type === actionTypes.GRAPH_QUERY.OPEN_MODAL) {
    return defaultsDeep(
      {
        showModal: true
      },
      state
    )
  }
  if (action.type === actionTypes.GRAPH_QUERY.CLOSE_MODAL) {
    return defaultsDeep(
      {
        showModal: false
      },
      state
    )
  }
  if (action.type === actionTypes.GRAPH_QUERY.REQUEST) {
    return {
      ...state,
      isFetching: true,
      failed: false,
      showModal: false,
    }
  }
  if (action.type === actionTypes.GRAPH_QUERY.SUCCESS) {
    return {
      ...state,
      isFetching: false,
      status: '',
    }
  }
  if (action.type === actionTypes.GRAPH_QUERY.CANCEL) {
    return {
      ...state,
      isFetching: false,
      status: '',
    }
  }
  if (action.type === actionTypes.GRAPH_QUERY.FAIL) {
    return {
      ...state,
      isFetching: false,
      failed: true,
      status: '',
    }
  }
  if (action.type === actionTypes.GRAPH_QUERY.SET_STATUS) {
    return {
      ...state,
      status: typeof action.payload === 'string' ? action.payload : '',
    }
  }
  return state
}
